import { tv } from '@change/ds-utils';

export const postTitleContainerStyles = tv({
	base: 'flex flex-col bg-[#E3E3E3] pt-[4px] pb-[6px]',
	variants: {
		isExpanded: {
			false: 'px-1.5',
			true: 'px-2.5',
		},
	},
});

export const profileContainerStyles = tv({
	base: 'w-[69%]',
	variants: {
		isExpanded: {
			false: 'px-0',
			true: 'px-1',
		},
	},
});

export const changeDotOrgCaptionStyles = tv({
	base: 'leading-[150%] font-medium tracking-[-0.088px]',
	variants: {
		isExpanded: {
			false: 'text-[8px]',
			true: 'text-xs',
		},
	},
});

export const petitionTitleStyles = tv({
	base: 'leading-[125%] font-bold tracking-[-0.099px]',
	variants: {
		isExpanded: {
			false: 'text-[9px]',
			true: 'text-[13px]',
		},
	},
});
